import React from 'react';

export default function FwOrganizationIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-university' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
